var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBagOfMoney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 69,
    viewBox: "0 0 68 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 33.6,
    cy: 34.4398,
    r: 33.6,
    fill: "#FFF5D9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_102_3077)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.7902 25.44H38.4094L40.4854 23.7792C41.1922 23.2152 41.4562 22.2996 41.1574 21.4452C40.8586 20.5908 40.0822 20.04 39.1798 20.04H28.0198C27.1174 20.04 26.341 20.592 26.0422 21.4452C25.7434 22.2984 26.0074 23.2152 26.713 23.778L28.7902 25.44Z",
    fill: "#FFBB38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.574 27.2402H28.626C25.3488 30.4574 22.8 36.1022 22.8 40.7402C22.8 44.771 24.9336 48.8402 29.7 48.8402H37.8C41.8716 48.8402 44.4 45.7358 44.4 40.7402C44.4 36.1022 41.8512 30.4574 38.574 27.2402ZM33.144 37.1402H34.056C35.4588 37.1402 36.6 38.2814 36.6 39.6842C36.6 40.9454 35.6904 41.9834 34.5 42.1946V43.139C34.5 43.6358 34.0968 44.039 33.6 44.039C33.1032 44.039 32.7 43.6358 32.7 43.139V42.2402H31.5C31.0032 42.2402 30.6 41.837 30.6 41.3402C30.6 40.8434 31.0032 40.4402 31.5 40.4402H34.056C34.4664 40.4402 34.8 40.1066 34.8 39.6962C34.8 39.2738 34.4664 38.9402 34.056 38.9402H33.144C31.7412 38.9402 30.6 37.799 30.6 36.3962C30.6 35.135 31.5096 34.097 32.7 33.8858V32.9402C32.7 32.4434 33.1032 32.0402 33.6 32.0402C34.0968 32.0402 34.5 32.4434 34.5 32.9402V33.8402H35.7C36.1968 33.8402 36.6 34.2434 36.6 34.7402C36.6 35.237 36.1968 35.6402 35.7 35.6402H33.144C32.7336 35.6402 32.4 35.9738 32.4 36.3842C32.4 36.8066 32.7336 37.1402 33.144 37.1402Z",
    fill: "#FFBB38"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_102_3077"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.8,
    height: 28.8,
    fill: "white",
    transform: "translate(19.2 20.04)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBagOfMoney);
export default __webpack_public_path__ + "static/media/bagOfMoney.cf3ec395a49d0a4ee24115a143b2d321.svg";
export { ForwardRef as ReactComponent };